<!--ESTILOS EXPLICADOS EN EL PARTIAL DE ESTILOS _BUTTONS.SCCS-->
<!--deshabilitamos el click del disabled en inline-->
<button [type]="type" mat-stroked-button [disabled]="disabled" color="primary" [style]="disabled ? 'pointer-events: auto' : 'none'">
  <ng-content></ng-content>
</button>
